import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { Item } from '../../../../common/snippets';
import BranchRechargeHistory from './BranchRechargeHistory';
import PartyRechargeHistory from './PartyRechargeHistory';
import * as mdt from '../../../../../../src/components/common/modaltypes'
import { connect } from 'react-redux';
import RechargeReqModal from '../../../../header/RechargeReqModal';
import { updateModal } from '../../../../../store/common/common_action';
const RechargeHistoryTab = (props) => {
    const {data,updateModal}=props;
    const {common}=data;
    const {modalType,loginData,showModal} = common
    const [senderSect] = useState(['BRANCH RECHARGE', 'PARTY RECHARGE']);
    const [senderSectContent, setSenderSectContent] = useState(0);

    const handleSenderSect = (event, newValue) => {
        setSenderSectContent(newValue);
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    const showRechargeRequestModal=()=>{
        let data = {
          headText: "Cargo | Recharge Request",
          loginData:loginData
      }
      return <RechargeReqModal data={data} updateModal={updateModal} />
    
      }
    return (
        <>
            <Item className='aka'
                sx={{
                    width: '100%',
                    // marginTop: '10px',
                    padding: '0px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: 1,
                    borderColor: 'divider',
                    paddingLeft:'17px'
                }}
            >
                {/* Tabs Section */}
                <Box>
                    <Tabs
                        value={senderSectContent}
                        onChange={handleSenderSect}
                        aria-label="basic tabs example"
                    >
                        {senderSect.map((reqType, index) => (
                            <Tab
                                key={`sender_${index}`}
                                label={reqType}
                                {...a11yProps(index)}
                                style={{ lineHeight: '2.5' }}
                            />
                        ))}
                    </Tabs>
                </Box>

                {/* Button Section */}
                <Box
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        cursor: 'pointer',
                        marginTop:'2px',
                        
                    }}
                >
                    <button
                        className="recharge-button"
                        style={{
                            // padding: '8px 16px', // Add padding for spacing
                            boxSizing: 'border-box', // Prevent padding from affecting layout
                            border: 'none',
                            height:'35px',
                            marginRight:'5px',
                            borderBottom:'1px solid #FF5722',
                            // backgroundColor: '#007BFF', // Example button color
                            // color: '#FFF', // Example text color
                            borderRadius: '4px', // Optional: rounded edges
                            lineHeight: 'normal', // Ensure consistent text spacing
                        }}
                        onClick={() => {updateModal(true, mdt.cargoRechargeRequestModal)}}
                    >
                        ₹ BRANCH / PARTY RECHARGE
                    </button>
                </Box>
            </Item>

            {/* Content Section */}
            {senderSectContent === 0 ? <BranchRechargeHistory /> : ''}
            {senderSectContent === 1 ? <PartyRechargeHistory /> : ''}
             {showModal && mdt.cargoRechargeRequestModal === modalType && showRechargeRequestModal()}
        </>
    );
};
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    updateModal
}
export default connect(mapStateToProps, mapDispatchToProps)(RechargeHistoryTab)
